import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '../../../_common/_service/authservice.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmPasswordValidator } from '../../../_common/_helper/confirm-password.validator';


@Component({
  selector: 'app-merchantlogin',
  templateUrl: './merchantlogin.component.html',
  styleUrls: ['./merchantlogin.component.scss']
})
export class MerchantloginComponent implements OnInit {
  loadingspinner: boolean = false;
  submitted = false;
  isAdd = true;
  hide = true;
  public myForm: FormGroup;
  cUser: any;
  isdCodeList: any;

  ServiceCountryList: any;

  ipAddress: any;
  

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private authService: AuthService,
    private router: Router,
    public dialogRef: MatDialogRef<MerchantloginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog
  ) {

    this.myForm = this.fb.group({
    
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      emailId: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,20}')]],
      ConfirmPassword: [null, [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,20}')]],
      isdCode: [null, Validators.required],
      mobileNo: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(13), Validators.minLength(1)]],
      userDeviceType: [3],
      userDeviceToken: [null],
      serviceid: [null, [Validators.required]],
      company: [null, Validators.required],
      businessLicense: [null, Validators.required],
      tin: [null, Validators.required],
      vat: [null, Validators.required],
      merchantAddress: [null, Validators.required],
      //merchantlogo: [null, Validators.required],
      postalCode: [null, Validators.required],
      bankName: [null, Validators.required],
      accountNumber: [null, Validators.required],
      bankCode: [null, Validators.required],
      IPAddress: [null]

    }, {
      validator: ConfirmPasswordValidator('password', 'ConfirmPassword')
    })
  }

  ngOnInit() {
    this.isdCodes(); 

    this.getServiceCountryList();
    this.getIPAddress();


  }
  
  // convenience getter for easy access to form fields
  get f() { return this.myForm.controls; }

  getIPAddress() {
    const response = fetch('https://api.ipify.org/?format=json')
      .then(response => response.json())
      .then(data => {
        this.ipAddress = data.ip;
      });
  }


  save(post: any) {
    
    this.submitted = true;
    if (this.myForm.valid) {
      post.IPAddress = this.ipAddress;
      post.serviceid = parseFloat(post.serviceid);
      this.loadingspinner = true;

      this.authService.merchantOnBoardRequest(post).subscribe(response => {
        this.loadingspinner = false;
        if (response.apiStatus == true) {
          this.toastr.success(response.apiMessage, 'Success');

          this.dialogRef.close();
        } else {
          this.toastr.error(response.apiMessage, 'Error');
        }
      }, (err: any) => {
        this.loadingspinner = false;
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {

          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  }


  getServiceCountryList() {

    this.submitted = true;

    this.authService.getServiceCountryList().subscribe(
      (response: { isSuccess: any; result: any; }) => {

        this.ServiceCountryList = response;
        var d = this.ServiceCountryList.filter((x: { serviceId: any; }) => x.serviceId != 5);


        this.ServiceCountryList = d;
      }, (err: any) => {
        this.toastr.error(err.error, 'Error');
      });
  }

  /**isdCodes */
  isdCodes() {
    this.authService.getIsdCodeSignup().subscribe(response => {

      this.isdCodeList = response;

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }

  

}
